module.exports = __webpack_public_path__ + "img/ArcEnciel_QR_Code.f83d1ca8.png";